<template>
  <Cascader
      ref="cascader"
      style="display: inherit;"
      clearable
      filterable
      v-model="search.value"
      :data="options"
      :change-on-select="true"
      :load-data="loadData"
      @on-change="emitSearchQuery"
      @on-visible-change="emitVisibleChange"
  ></Cascader>
</template>

<script>
export default {
  props: {
    search: {
      type: Object
    }
  },
  data () {
    return {
      options: []
    }
  },
  created () {
    // this.search.value = this.search.value || '';
    if (!this.search.componentAttr) {
      if (this.search.request) {
        this.fetchOptionList({children: this.options, request: this.search.request});
      }
    } else {
      this.options = this.search.componentAttr.options || [];
    }
  },
  watch: {
  },
  methods: {
    async loadData (item, callback) {
      item.loading = true;
      // 获取数据
      if (item.request) {
        await this.fetchOptionList(item);
      }
      item.loading = false;
      callback();

      if (item.children.length === 0) {
        delete item.children;
        delete item.loading;
        this.$refs['cascader'].$refs['caspanel'].handleClickItem(item);
      }
      // this.selectLabel
    },

    emitSearchQuery (item, selectedData) {
      const _self = this;
      // 将值往上传
      // iview 组件问题，先执行了on-select,导致value未被更新
      _self.$nextTick(function () {
        _self.$emit('getSearchValueChange', _self.search);
      });
    },

    emitVisibleChange (showFlag) {
      if (!showFlag) {
        const _self = this;
        // 将值往上传
        _self.$emit('enter');
      }
    },

    fetchOptionList (curItem) {
      const _self = this;

      let options = curItem.children;
      let request = curItem.request;
      let parentId = curItem.value;
      return new Promise((resolve, reject) => {
        // {parentId} 内容替换
        let query = JSON.parse(JSON.stringify(request.data).replace('{parentId}', parentId));
        _self[request.method](request.addr, query).then(res => {
          let list = [];
          if (Array.isArray(res.data)) {
            list = res.data;
          } else if (typeof res.data === 'object' && Array.isArray(res.data.list)) {
            list = res.data.list;
          }
          if (list.length > 0) {
            let value = 'value';
            let label = 'label';
            if (request.format) {
              value = request.format.value;
              label = request.format.label;
            }
            for (let item of list) {
              // 如果还有下一级，加上children属性
              if (request.children && request.children.request) {
                if (Array.isArray(label)) {
                  let word = '';
                  for (let l of label) {
                    if (word) word = word + '(' + item[l] + ')';
                    else word = item[l];
                  }
                  options.push({
                    id: item.id,
                    value: item[value],
                    label: word,
                    children: [],
                    loading: false,
                    request: request.children.request
                  });
                } else {
                  options.push({
                    id: item.id,
                    value: item[value],
                    label: item[label],
                    children: [],
                    loading: false,
                    request: request.children.request
                  });
                }
              } else {
                if (Array.isArray(label)) {
                  let word = '';
                  for (let l of label) {
                    if (word) word = word + '(' + item[l] + ')';
                    else word = item[l];
                  }
                  options.push({
                    id: item.id,
                    value: item[value],
                    label: word
                  });
                } else {
                  options.push({
                    id: item.id,
                    value: item[value],
                    label: item[label]
                  });
                }
              }
            }
          }
          delete curItem.request;
          resolve();
        });
      });
    }
  }
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/regularQuery/cascader.vue